import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./edit-recipient-modal.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./edit-recipient-modal.component.scss?ngResource";
import { ChangeDetectorRef, Component, Input } from "@angular/core";
import { DefaultRequiredFields } from "../../../../../models/application/generic/recipient.model";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../constants/shared.constants";
import { Subject, take } from "rxjs";
import { RecipientFormConstants } from "../../shared-contants/recipient-shared.constants";
import { RecipientService } from "../../shared-services/recipient.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppControllerService } from "../../../../../../app-controller.service";
import RecipientUtils from "../../../../../utils/recipient-utils";
import { AlertType } from "../../../../../models/alert";
import { phoneNumberValidator } from "../../../../../classes/phone-number-validator";
import { RecipientSelectConstants } from "../../../recipient-select/recipient-select.constants";
import { LookupConstants } from "../../../../../constants/lookup.constants";
import { AppConfig } from "../../../../../../app.config";
let EditRecipientModalComponent = class EditRecipientModalComponent {
    changeDetectorRef;
    recipientService;
    activeModal;
    appControllerService;
    dialogTitle = "Add new recipient";
    groupsFromMetadata = [];
    jobId;
    moduleId;
    groupsOptions = [];
    recipientToEdit;
    selectedRecipientGroups;
    showRecipientGroupsDropdown = true;
    showDefaultCommunicationMethods = true;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    editRecipientForm;
    Validator = Validators;
    sameAsResidentialChecked = false;
    disableEditing = false;
    provinceOptions = LookupConstants.PROVINCE;
    countryOptions = LookupConstants.COUNTRIES;
    groupsOptionsObservable = new Subject();
    selectedGroupsOptionsSubject = new Subject();
    defaultRequiredFields = DefaultRequiredFields;
    requiredFieldsPlaceHolder = RecipientFormConstants.requireFieldKey;
    selectOptionText = SharedConstants.NO_OPTION_SELECTED;
    maritalStatusOptions = LookupConstants.MARITAL_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    relativeDetailsBodyLabel = RecipientSelectConstants.relativeDetailsBodyLabel;
    employersDetailsHeader = RecipientSelectConstants.employerDetailsHeader;
    employmentStatusOptions = LookupConstants.EMPLOYMENT_STATUS_LOOKUPS_RECIPIENT_COMPONENTS;
    recipientGroupSettings = [];
    formName = "editRecipient";
    validationMessage = RecipientFormConstants.validationMessage;
    nameLabel = RecipientFormConstants.nameLabel;
    surnameLabel = RecipientFormConstants.surnameLabel;
    homePhoneTelephoneLabel = RecipientFormConstants.homeTelePhoneLabel;
    workTelephoneLabel = RecipientFormConstants.workTelephoneLabel;
    cellphoneLabel = RecipientFormConstants.cellphoneLabel;
    emailLabel = RecipientFormConstants.emailLabel;
    passportNumberLabel = RecipientFormConstants.passportNumberLabel;
    defaultCommunicationMethodLabel = RecipientFormConstants.defaultCommunicationMethodLabel;
    organisationLabel = RecipientFormConstants.organisationLabel;
    clientVatNumberLabel = RecipientFormConstants.clientVatNumberLabel;
    designationLabel = RecipientFormConstants.designationLabel;
    professionalBodyHeader = RecipientFormConstants.professionalBodyHeader;
    professionalBodyLabel = RecipientFormConstants.professionalBodyLabel;
    professionalBodyRegNoLabel = RecipientFormConstants.professionalBodyRegNoLabel;
    maritalStatusLabel = RecipientSelectConstants.maritalStatusLabel;
    idNumberLabel = RecipientSelectConstants.idNumberLabel;
    relativesFullNameLabel = RecipientSelectConstants.relativesFullNameLabel;
    relativesContactNumberLabel = RecipientSelectConstants.relativesContactNumberLabel;
    relativesAddressLabel = RecipientSelectConstants.relativesAddressLabel;
    employmentStatusLabel = RecipientSelectConstants.employmentStatusLabel;
    employersNameLabel = RecipientSelectConstants.employersNameLabel;
    employersContactNumberLabel = RecipientSelectConstants.employersContactNumberLabel;
    employersAddressLabel = RecipientSelectConstants.employersAddressLabel;
    streetAddressHeader = RecipientFormConstants.streetAddressHeader;
    streetAddressLabel = RecipientFormConstants.streetAddressLabel;
    streetSuburbLabel = RecipientFormConstants.streetSuburbLabel;
    streetCityLabel = RecipientFormConstants.streetCityLabel;
    streetProvinceLabel = RecipientFormConstants.streetProvinceLabel;
    streetCountryLabel = RecipientFormConstants.streetCountryLabel;
    streetCodeLabel = RecipientFormConstants.streetCodeLabel;
    postalDetailsHeader = RecipientFormConstants.postalDetailsHeader;
    postalAddressLabel = RecipientFormConstants.postalAddressLabel;
    postalSuburbLabel = RecipientFormConstants.postalSuburbLabel;
    postalCityLabel = RecipientFormConstants.postalCityLabel;
    postalProvinceLabel = RecipientFormConstants.postalProvinceLabel;
    postalCountryLabel = RecipientFormConstants.postalCountryLabel;
    postalCodeLabel = RecipientFormConstants.postalCodeLabel;
    sameAsStreetAddressLabel = RecipientFormConstants.sameAsStreetAddressLabel;
    groupsHeader = RecipientFormConstants.groups;
    groupsLabel = RecipientFormConstants.groupsLabel;
    selectOptionTextOption = RecipientSelectConstants.PLEASE_SELECT_AN_OPTION;
    // Form Controls
    nameFormControlName = RecipientFormConstants.nameFormControl;
    surnameFormControlName = RecipientFormConstants.surnameFormControl;
    homePhoneFormControlName = RecipientFormConstants.homeTelePhoneFormControl;
    workTelephoneFormControlName = RecipientFormConstants.workTelephoneFormControl;
    cellphoneFormControlName = RecipientFormConstants.cellphoneFormControlName;
    emailFormControlName = RecipientFormConstants.emailFormControlName;
    passportNumberFormControlName = RecipientFormConstants.passportNumberFormControlName;
    defaultCommunicationMethodFormControlName = RecipientSelectConstants.defaultCommunicationMethodFormControlName;
    emailRadioButtonLabel = RecipientFormConstants.emailRadioButtonLabel;
    smsRadioButtonLabel = RecipientSelectConstants.smsRadioButtonLabel;
    organisationFormControlName = RecipientFormConstants.organisationFormControlName;
    clientVatNumberFormControlName = RecipientFormConstants.clientVatNumberFormControlName;
    designationFormControlName = RecipientFormConstants.designationFormControlName;
    professionalBodyFormControlName = RecipientFormConstants.professionalBodyFormControlName;
    professionalBodyRegNoFormControlName = RecipientFormConstants.professionalBodyRegNoFormControlName;
    maritalStatusFormControlName = RecipientSelectConstants.maritalStatusFormControlName;
    idNumberFormControlName = RecipientSelectConstants.idNumberFormControlName;
    relativesFullNameFormControlName = RecipientSelectConstants.relativesFullNameFormControlName;
    relativesContactNumberFormControlName = RecipientSelectConstants.relativesContactNumberFormControlName;
    relativesAddressFormControlName = RecipientSelectConstants.relativesAddressFormControlName;
    employmentStatusFormControlName = RecipientSelectConstants.employmentStatusFormControlName;
    employersNameFormControlName = RecipientSelectConstants.employersNameFormControlName;
    employersContactNumberFormControlName = RecipientSelectConstants.employersContactNumberFormControlName;
    employersAddressFormControlName = RecipientSelectConstants.employersAddressFormControlName;
    streetAddressFormControlName = RecipientFormConstants.streetAddressFormControlName;
    streetSuburbFormControlName = RecipientFormConstants.streetSuburbFormControlName;
    streetCityFormControlName = RecipientFormConstants.streetCityFormControlName;
    streetProvinceFormControlName = RecipientFormConstants.streetProvinceFormControlName;
    streetCountryFormControlName = RecipientFormConstants.streetCountryFormControlName;
    streetCodeFormControlName = RecipientFormConstants.streetCodeFormControlName;
    postalAddressFormControlName = RecipientFormConstants.postalAddressFormControlName;
    postalSuburbFormControlName = RecipientFormConstants.postalSuburbFormControlName;
    postalCityFormControlName = RecipientFormConstants.postalCityFormControlName;
    postalProvinceFormControlName = RecipientFormConstants.postalProvinceFormControlName;
    postalCountryFormControlName = RecipientFormConstants.postalCountryFormControlName;
    postalCodeFormControlName = RecipientFormConstants.postalCodeFormControlName;
    groupsStringArrayFormControlName = RecipientFormConstants.groupsStringArrayFormControlName;
    maximunLengthForThentyWord = 20;
    maximunLengthForFiftyWord = 50;
    maximunLengthForHundredWord = 100;
    maximunLengthForTwoFiftyWord = 250;
    maximunLengthFiveHundredWord = 500;
    cancelBtnPlaceholder = SharedConstants.CANCEL_LABEL;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    newRecipientFormLabelHeading = "Recipient details";
    // control visibility
    showNameField = true;
    showSurnameField = true;
    showHomeTelephoneField = true;
    showWorkTelephoneField = true;
    showCellphoneField = true;
    showEmailField = true;
    showPassportNumberField = true;
    showOrganisationField = true;
    showDesignationField = true;
    showProfessionalBodyField = true;
    showProfessionalBodyRegNumField = true;
    showStreetAddressField = true;
    showStreetSuburbField = true;
    showStreetCityField = true;
    showStreetProvinceField = true;
    showStreetCountryField = true;
    showStreetCodeField = true;
    showPostalAddressField = true;
    showPostalSuburbField = true;
    showPostalCityField = true;
    showPostalProvinceField = true;
    showPostalCountryField = true;
    showPostalCodeField = true;
    showClientVatNumberField = true;
    showMaritalStatusField = true;
    showRelativesFullNameField = true;
    showRelativesContactNumberField = true;
    showRelativesAddressField = true;
    showEmploymentStatusField = true;
    showEmployersNameField = true;
    showEmployersContactNumberField = true;
    showEmployersAddressField = true;
    showIdNumberField = true;
    showSave = true;
    constructor(changeDetectorRef, recipientService, activeModal, appControllerService) {
        this.changeDetectorRef = changeDetectorRef;
        this.recipientService = recipientService;
        this.activeModal = activeModal;
        this.appControllerService = appControllerService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
    }
    ngOnInit() {
        this.editRecipientForm = new FormGroup({
            id: new FormControl(this.recipientToEdit.id),
            jobId: new FormControl(this.recipientToEdit.jobId ? this.recipientToEdit.jobId : null),
            moduleId: new FormControl(this.recipientToEdit.moduleId ? this.recipientToEdit.moduleId : null),
            name: new FormControl(this.recipientToEdit.name ? this.recipientToEdit.name : null),
            surname: new FormControl(this.recipientToEdit.surname ? this.recipientToEdit.surname : null),
            homePhone: new FormControl(this.recipientToEdit.homePhone ? this.recipientToEdit.homePhone : null, phoneNumberValidator),
            telephone: new FormControl(this.recipientToEdit.telephone ? this.recipientToEdit.telephone : null, phoneNumberValidator),
            cellphone: new FormControl(this.recipientToEdit.cellphone ? this.recipientToEdit.cellphone : null, phoneNumberValidator),
            email: new FormControl(this.recipientToEdit.email ? this.recipientToEdit.email : null, Validators.email),
            passportNumber: new FormControl(this.recipientToEdit.passportNumber ? this.recipientToEdit.passportNumber : null),
            defaultCommunicationMethod: new FormControl(this.recipientToEdit.defaultCommunicationMethod ? this.recipientToEdit.defaultCommunicationMethod : null),
            organisation: new FormControl(this.recipientToEdit.organisation ? this.recipientToEdit.organisation : null),
            clientVatNumber: new FormControl(this.recipientToEdit.clientVatNumber ? this.recipientToEdit.clientVatNumber : null),
            designation: new FormControl(this.recipientToEdit.designation ? this.recipientToEdit.designation : null),
            professionalBody: new FormControl(this.recipientToEdit.professionalBody ? this.recipientToEdit.professionalBody : null),
            professionalBodyRegNum: new FormControl(this.recipientToEdit.professionalBodyRegNum ? this.recipientToEdit.professionalBodyRegNum : null),
            maritalStatus: new FormControl(this.recipientToEdit.maritalStatus ? this.recipientToEdit.maritalStatus : null),
            idNumber: new FormControl(this.recipientToEdit.idNumber ? this.recipientToEdit.idNumber : null),
            relativesFullName: new FormControl(this.recipientToEdit.relativesFullName ? this.recipientToEdit.relativesFullName : null),
            relativesContactNumber: new FormControl(this.recipientToEdit.relativesContactNumber ? this.recipientToEdit.relativesContactNumber : null),
            relativesAddress: new FormControl(this.recipientToEdit.relativesAddress ? this.recipientToEdit.relativesAddress : null),
            employmentStatus: new FormControl(this.recipientToEdit.employmentStatus ? this.recipientToEdit.employmentStatus : null),
            employersName: new FormControl(this.recipientToEdit.employersName ? this.recipientToEdit.employersName : null),
            employersContactNumber: new FormControl(this.recipientToEdit.employersContactNumber ? this.recipientToEdit.employersContactNumber : null),
            employersAddress: new FormControl(this.recipientToEdit.employersAddress ? this.recipientToEdit.employersAddress : null),
            streetAddress: new FormControl(this.recipientToEdit.streetAddress ? this.recipientToEdit.streetAddress : null),
            streetSuburb: new FormControl(this.recipientToEdit.streetSuburb ? this.recipientToEdit.streetSuburb : null),
            streetCity: new FormControl(this.recipientToEdit.streetCity ? this.recipientToEdit.streetCity : null),
            streetProvince: new FormControl(this.recipientToEdit.streetProvince ? this.recipientToEdit.streetProvince : null),
            streetCountry: new FormControl(this.recipientToEdit.streetCountry ? this.recipientToEdit.streetCountry : null),
            streetCode: new FormControl(this.recipientToEdit.streetCode ? this.recipientToEdit.streetCode : null),
            postalAddress: new FormControl(this.recipientToEdit.postalAddress ? this.recipientToEdit.postalAddress : null),
            postalSuburb: new FormControl(this.recipientToEdit.postalSuburb ? this.recipientToEdit.postalSuburb : null),
            postalCity: new FormControl(this.recipientToEdit.postalCity ? this.recipientToEdit.postalCity : null),
            postalProvince: new FormControl(this.recipientToEdit.postalProvince ? this.recipientToEdit.postalProvince : null),
            postalCountry: new FormControl(this.recipientToEdit.postalCountry ? this.recipientToEdit.postalCountry : null),
            postalCode: new FormControl(this.recipientToEdit.postalCode ? this.recipientToEdit.postalCode : null),
            groupsStringArray: new FormControl(this.getGroupsStringArray(this.recipientToEdit.groups)),
            groups: new FormControl(this.recipientToEdit.groups ? this.recipientToEdit.groups : null)
        });
        this.loadRecipientGroupSettings();
    }
    loadRecipientGroupSettings() {
        if (this.recipientGroupSettings.length === 0) {
            this.recipientService.getRecipientGroupSettings(+this.appControllerService.selectedModuleID, false).pipe(take(1)).subscribe({
                next: (response) => {
                    this.recipientGroupSettings = response;
                    this.checkRequiredFields();
                }, error: (error) => {
                    this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
                }
            });
        }
    }
    ngAfterViewInit() {
        this.populateRecipientGroups();
        this.checkIfPostalDetailsIsTheSameAsResidentialDetails(this.recipientToEdit);
    }
    ngOnDestroy() {
        this.selectedGroupsOptionsSubject.unsubscribe();
        this.groupsOptionsObservable.unsubscribe();
    }
    onResidentialInputEntered($event, postalAddressFormControlName) {
        RecipientUtils.onResidentialInputEntered($event, postalAddressFormControlName, this.editRecipientForm, this.sameAsResidentialChecked);
    }
    onSameAsResidentialChecked($event) {
        const checkBoxStatus = $event.target.checked;
        if (checkBoxStatus) {
            this.sameAsResidentialChecked = true; // checks the checkbox and disables fields
            RecipientUtils.copyStreetDetailsDataToPostalDetailsFields(this.editRecipientForm, this.sameAsResidentialChecked);
            RecipientUtils.clearPostalDetailsValidators(this.editRecipientForm, this.sameAsResidentialChecked);
        }
        else {
            this.sameAsResidentialChecked = false;
            RecipientUtils.enablePostalDetails(this.editRecipientForm);
            RecipientUtils.restorePostalDetailsValidators(this.editRecipientForm, this.groupsFromMetadata);
            this.editRecipientForm.updateValueAndValidity();
            this.changeDetectorRef.detectChanges();
        }
    }
    enablePostalSelects(postalProvinceFormControlName) {
        RecipientUtils.enablePostalSelects(this.editRecipientForm, postalProvinceFormControlName, this.sameAsResidentialChecked);
    }
    disablePostalSelects(postalProvinceFormControlName) {
        RecipientUtils.disablePostalSelects(this.editRecipientForm, postalProvinceFormControlName, this.sameAsResidentialChecked);
    }
    onCancelBtnClicked() {
        this.activeModal.close();
    }
    onSaveBtnClicked() {
        if (this.editRecipientForm.valid) {
            this.editRecipientForm.enable();
            const newRecipient = this.editRecipientForm.value;
            newRecipient.jobId = this.jobId ? +this.jobId : null;
            newRecipient.moduleId = this.moduleId;
            if (newRecipient.groupsStringArray && newRecipient.groupsStringArray.groups) {
                newRecipient.groupsStringArray = newRecipient.groupsStringArray.groups;
            }
            else {
                newRecipient.groups = [];
            }
            delete newRecipient.groups;
            this.activeModal.close(newRecipient);
        }
        else {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    updateModel() {
    }
    onRadioButtonChanged(selectedMethodOfCommunication) {
        const preferredMethodOfCommunication = selectedMethodOfCommunication.trim().toLowerCase();
        const emailFormControl = this.editRecipientForm.get(this.emailFormControlName);
        const cellphoneFormControl = this.editRecipientForm.get(this.cellphoneFormControlName);
        const recipientGroup = this.groupsFromMetadata[0];
        const isCellPhoneRequiredFromMetaData = this.isCellphoneFormFieldRequiredInTheMetadata(recipientGroup);
        const isEmailRequiredFromMetadata = this.isEmailFormFieldRequiredInTheMetadata(recipientGroup);
        if (preferredMethodOfCommunication.toLowerCase().trim() === "email") {
            this.setEmailFormFieldAsRequired(emailFormControl);
            if (isCellPhoneRequiredFromMetaData) {
                this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            }
            else {
                this.clearCellphoneFormFieldRequiredValidation(cellphoneFormControl);
            }
        }
        if (preferredMethodOfCommunication.toLowerCase().trim() === "sms") {
            this.setCellphoneFormFieldAsRequired(cellphoneFormControl);
            // if (isEmailRequiredFromMetadata) {
            //   this.setEmailFormFieldAsRequired(emailFormControl);
            // } else {
            //   this.clearEmailFormFieldRequiredValidation(emailFormControl);
            // }
        }
    }
    populateRecipientGroups() {
        // populates the groups
        this.groupsOptions?.sort((a, b) => a?.localeCompare(b));
        this.changeDetectorRef.detectChanges();
    }
    checkRequiredFields() {
        const group = this.groupsFromMetadata[0];
        if (this.recipientGroupSettings.length > 0) {
            const settings = this.recipientGroupSettings.find(x => x.name === group.groupName && x.type === group.groupType);
            if (settings) {
                group.requiredFields = JSON.parse(settings.configuration);
                this.loadRequiredFields(group);
                this.editRecipientForm.updateValueAndValidity();
            }
            else {
                this.showSave = false;
                this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
            }
        }
        else {
            this.showSave = false;
            this.appControllerService.showMessage("Configuration for recipient group settings incomplete", AlertType.Error);
        }
    }
    checkIfPostalDetailsIsTheSameAsResidentialDetails(recipient) {
        const postalDetailsMatchResidentialDetails = RecipientUtils.checkAddressDetails(recipient, this.editRecipientForm);
        if (postalDetailsMatchResidentialDetails) {
            RecipientUtils.disablePostalDetails(this.editRecipientForm);
            this.sameAsResidentialChecked = true;
            this.changeDetectorRef.detectChanges();
        }
    }
    getGroupsStringArray(groups) {
        const groupsStringArray = [];
        if (groups && groups.length > 0) {
            groups.forEach((group) => {
                groupsStringArray.push(group.groupName);
            });
        }
        return groupsStringArray;
    }
    loadRequiredFields(data) {
        data.requiredFields.forEach((item) => {
            item.name = this.formatObjectKey(item.name);
            const control = this.editRecipientForm.get(item.name);
            if (item.required) {
                control.addValidators([Validators.required]);
                if (item.name === RecipientFormConstants.homeTelePhoneFormControl) {
                    control.addValidators([phoneNumberValidator]);
                }
                if (item.name === RecipientFormConstants.workTelephoneFormControl) {
                    control.addValidators([phoneNumberValidator]);
                }
                if (item.name === RecipientFormConstants.cellphoneFormControlName) {
                    control.addValidators([phoneNumberValidator]);
                }
                if (item.name === RecipientFormConstants.streetCodeFormControlName) {
                    control.addValidators([Validators.minLength(4)]);
                }
                if (item.name === RecipientFormConstants.postalCodeFormControlName) {
                    control.addValidators([Validators.minLength(4)]);
                }
                if (item.name === RecipientFormConstants.emailFormControlName) {
                    control.addValidators([Validators.email]);
                }
                if (item.name === RecipientFormConstants.defaultCommunicationMethodFormControlName) {
                    // Optional: If this is a requirement for email or SMS, handle it here.
                }
                control.updateValueAndValidity();
            }
            this.showOrHideControl(item.name, item.visible);
        });
        this.editRecipientForm.updateValueAndValidity();
        this.changeDetectorRef.markForCheck();
    }
    formatObjectKey(name) {
        const wordArr = name.split(" ");
        wordArr.forEach((word, index) => {
            wordArr[index] = word.charAt(0).toUpperCase() + word.slice(1);
        });
        name = wordArr.join("");
        let keyToChange = name;
        if (keyToChange.toLocaleLowerCase() === "professionalbodyregistrationnumber") {
            keyToChange = "professionalBodyRegNum";
        }
        if (keyToChange === "Homephone") {
            keyToChange = "HomePhone";
        }
        const formattedString = keyToChange.charAt(0).toLowerCase() + keyToChange.slice(1);
        return formattedString;
    }
    isCellphoneFormFieldRequiredInTheMetadata(recipientGroup) {
        let isCellphoneRequired = false;
        if (this.groupsFromMetadata.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Cellphone", "cellphone")) {
            isCellphoneRequired = true;
        }
        return isCellphoneRequired;
    }
    isEmailFormFieldRequiredInTheMetadata(recipientGroup) {
        let isEsmailRequired = false;
        if (this.groupsFromMetadata.length > 0 && recipientGroup.hasOwnProperty(this.requiredFieldsPlaceHolder) && this.getPropertyThatMatchesDataCase(recipientGroup.requiredFields, "Email", "email")) {
            isEsmailRequired = true;
        }
        return isEsmailRequired;
    }
    setEmailFormFieldAsRequired(emailFormControl) {
        emailFormControl.setValidators([Validators.required, Validators.email]);
        emailFormControl.updateValueAndValidity();
    }
    setCellphoneFormFieldAsRequired(cellphoneFormControl) {
        cellphoneFormControl.setValidators([Validators.required, phoneNumberValidator]);
        cellphoneFormControl.updateValueAndValidity();
    }
    clearCellphoneFormFieldRequiredValidation(cellphoneFormControl) {
        cellphoneFormControl.clearValidators();
        cellphoneFormControl.addValidators(phoneNumberValidator);
    }
    clearEmailFormFieldRequiredValidation(emailFormControl) {
        emailFormControl.clearValidators();
        emailFormControl.addValidators(Validators.email);
    }
    getPropertyThatMatchesDataCase(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    showOrHideControl(controlName, visible) {
        switch (controlName) {
            case this.nameFormControlName:
                this.showNameField = visible;
                break;
            case this.surnameFormControlName:
                this.showSurnameField = visible;
                break;
            case this.homePhoneFormControlName:
                this.showHomeTelephoneField = visible;
                break;
            case this.workTelephoneFormControlName:
                this.showWorkTelephoneField = visible;
                break;
            case this.cellphoneFormControlName:
                this.showCellphoneField = visible;
                break;
            case this.emailFormControlName:
                this.showEmailField = visible;
                break;
            case this.passportNumberFormControlName:
                this.showPassportNumberField = visible;
                break;
            case this.idNumberFormControlName:
                this.showIdNumberField = visible;
                break;
            case this.organisationFormControlName:
                this.showOrganisationField = visible;
                break;
            case this.designationFormControlName:
                this.showDesignationField = visible;
                break;
            case this.professionalBodyFormControlName:
                this.showProfessionalBodyField = visible;
                break;
            case this.professionalBodyRegNoFormControlName:
                this.showProfessionalBodyRegNumField = visible;
                break;
            case this.maritalStatusFormControlName:
                this.showMaritalStatusField = visible;
                break;
            case this.relativesFullNameFormControlName:
                this.showRelativesFullNameField = visible;
                break;
            case this.clientVatNumberFormControlName:
                this.showClientVatNumberField = visible;
                break;
            case this.relativesContactNumberFormControlName:
                this.showRelativesContactNumberField = visible;
                break;
            case this.relativesAddressFormControlName:
                this.showRelativesAddressField = visible;
                break;
            case this.employmentStatusFormControlName:
                this.showEmploymentStatusField = visible;
                break;
            case this.employersNameFormControlName:
                this.showEmployersNameField = visible;
                break;
            case this.employersContactNumberFormControlName:
                this.showEmployersContactNumberField = visible;
                break;
            case this.employersAddressFormControlName:
                this.showEmployersAddressField = visible;
                break;
            case this.streetAddressFormControlName:
                this.showStreetAddressField = visible;
                break;
            case this.streetCityFormControlName:
                this.showStreetCityField = visible;
                break;
            case this.streetSuburbFormControlName:
                this.showStreetSuburbField = visible;
                break;
            case this.streetProvinceFormControlName:
                this.showStreetProvinceField = visible;
                break;
            case this.streetCountryFormControlName:
                this.showStreetCountryField = visible;
                break;
            case this.streetCodeFormControlName:
                this.showStreetCodeField = visible;
                break;
            case this.postalAddressFormControlName:
                this.showPostalAddressField = visible;
                break;
            case this.postalCityFormControlName:
                this.showPostalCityField = visible;
                break;
            case this.postalSuburbFormControlName:
                this.showPostalSuburbField = visible;
                break;
            case this.postalProvinceFormControlName:
                this.showPostalProvinceField = visible;
                break;
            case this.postalCountryFormControlName:
                this.showPostalCountryField = visible;
                break;
            case this.postalCodeFormControlName:
                this.showPostalCodeField = visible;
                break;
            default:
                break;
        }
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: RecipientService },
        { type: NgbActiveModal },
        { type: AppControllerService }
    ];
    static propDecorators = {
        dialogTitle: [{ type: Input }],
        groupsFromMetadata: [{ type: Input }],
        jobId: [{ type: Input }],
        moduleId: [{ type: Input }],
        groupsOptions: [{ type: Input }],
        recipientToEdit: [{ type: Input }],
        selectedRecipientGroups: [{ type: Input }],
        showRecipientGroupsDropdown: [{ type: Input }],
        showDefaultCommunicationMethods: [{ type: Input }]
    };
};
EditRecipientModalComponent = __decorate([
    Component({
        selector: "app-edit-recipient-modal",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], EditRecipientModalComponent);
export { EditRecipientModalComponent };
